import { NotesManagerContent } from "@/features/notes-manager";
import { DEFAULT_NOTE_TYPES } from "@/services/api";
import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { CommitmentsTab as CommitmentsTabMobile } from "@/pages/ContactsPage/Tabs";
import { useNotesManager } from "../model";

export const CommitmentsTab = () => {
  const notesManager = useNotesManager();

  return (
    <ResponsiveBlockSwitcher
      desktop={
        <NotesManagerContent
          notesManager={notesManager}
          noteType={DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT}
          contactsPage
        />
      }
      mobile={<CommitmentsTabMobile />}
    />
  );
};
